import { Button, TextField } from '@chronosphereio/chrono-ui';
import { useState } from 'react';

interface AliasInputProps {
  alias: string;
  onChange: (alias: string) => void;
}

export const AliasInput = (props: AliasInputProps) => {
  const { alias, onChange } = props;
  const [value, setValue] = useState(alias);
  const [isEditing, setIsEditing] = useState(alias ? true : false);

  const handleAliasClick = () => {
    setIsEditing(true);
  };

  const handleAliasChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value);
  };

  const handleAliasBlur = () => {
    setIsEditing(false);
    onChange(value);
  };

  return (
    <div>
      {isEditing || alias ? (
        <TextField value={value} size={'medium'} onChange={handleAliasChange} onBlur={handleAliasBlur} label="Alias" />
      ) : (
        <Button onClick={handleAliasClick} size="small" variant="tertiary">
          Alias
        </Button>
      )}
    </div>
  );
};
